<template>
  <div class="privacy-page">
    <div class="privacy-container">
      <div class="privacy-header">
        <h1 class="privacy-title">隐私政策</h1>
      </div>
      <div class="privacy-content" v-html="content"></div>
      <div class="privacy-footer">
        <a-button type="primary" @click="handleBack">返回登录</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { queryByGroupAndName } from '@/api/app/config'

export default {
  name: 'PrivacyPolicy',
  data() {
    return {
      content: '',
      loading: false,
    }
  },
  created() {
    this.loadContent()
  },
  methods: {
    async loadContent() {
      this.loading = true
      try {
        // 调用后端接口获取隐私政策内容
        // configGroup: protocol, configName: privacyPolicy
        const response = await queryByGroupAndName({
          configGroup: 'protocol',
          configName: 'privacyPolicy',
        })
        if (response && response.data && response.data.configValue) {
          this.content = response.data.configValue
        } else {
          // 如果没有配置，显示默认内容
          this.content = this.getDefaultContent()
        }
      } catch (error) {
        console.error('加载隐私政策失败:', error)
        // 加载失败时显示默认内容
        this.content = this.getDefaultContent()
      } finally {
        this.loading = false
      }
    },
    getDefaultContent() {
      return `
        <div class="default-content">
          <h2>隐私政策</h2>
          <p>弘笃智慧云管理系统（以下简称"我们"）非常重视用户的隐私保护。本隐私政策说明了我们如何收集、使用、存储和保护您的个人信息。</p>
          <h3>一、信息收集</h3>
          <p>1. 我们可能收集以下信息：</p>
          <p>（1）账号信息：用户名、密码等注册信息；</p>
          <p>（2）使用信息：您在使用系统时的操作记录、登录日志等；</p>
          <p>（3）设备信息：设备型号、操作系统版本、IP地址等。</p>
          <h3>二、信息使用</h3>
          <p>我们使用收集的信息用于：</p>
          <p>1. 提供、维护和改进我们的服务；</p>
          <p>2. 处理您的请求和交易；</p>
          <p>3. 发送系统通知和重要信息；</p>
          <p>4. 进行数据分析，优化用户体验。</p>
          <h3>三、信息存储</h3>
          <p>我们采用行业标准的安全措施来保护您的个人信息，防止未经授权的访问、使用或泄露。</p>
          <h3>四、信息共享</h3>
          <p>我们不会向第三方出售、交易或转让您的个人信息，除非：</p>
          <p>1. 获得您的明确同意；</p>
          <p>2. 法律法规要求；</p>
          <p>3. 为提供服务所必需。</p>
          <h3>五、您的权利</h3>
          <p>您有权：</p>
          <p>1. 访问、更正或删除您的个人信息；</p>
          <p>2. 撤回您对信息处理的同意；</p>
          <p>3. 要求我们停止处理您的个人信息。</p>
          <h3>六、政策更新</h3>
          <p>我们可能会不定期更新本隐私政策，更新后的政策将在系统中公布。</p>
          <p class="update-time">最后更新时间：${new Date().toLocaleDateString(
            'zh-CN'
          )}</p>
        </div>
      `
    },
    handleBack() {
      this.$router.push('/user/login')
    },
  },
}
</script>

<style lang="less" scoped>
.privacy-page {
  min-height: 100vh;
  background: #f5f5f5;
  padding: 40px 20px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
.privacy-container {
  max-width: 900px;
  width: 100%;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}
.privacy-header {
  padding: 32px 40px;
  border-bottom: 1px solid #e8e8e8;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  .privacy-title {
    margin: 0;
    font-size: 28px;
    font-weight: 600;
    color: #ffffff;
    text-align: center;
  }
}
.privacy-content {
  padding: 40px;
  min-height: 400px;
  line-height: 1.8;
  color: #333;
  font-size: 14px;
  /deep/ h2 {
    font-size: 24px;
    font-weight: 600;
    color: #1890ff;
    margin: 24px 0 16px 0;
  }

  /deep/ h3 {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 20px 0 12px 0;
  }

  /deep/ p {
    margin: 12px 0;
    color: #666;
    text-align: justify;
  }

  /deep/ .update-time {
    margin-top: 32px;
    color: #999;
    font-size: 12px;
    text-align: right;
  }

  /deep/ .default-content {
    h2 {
      text-align: center;
      margin-bottom: 24px;
    }
  }
}
.privacy-footer {
  padding: 24px 40px;
  border-top: 1px solid #e8e8e8;
  text-align: center;
  background: #fafafa;
  .ant-btn {
    min-width: 120px;
    height: 40px;
  }
}
</style>
